import ky from "ky";
import Markdown from "react-markdown";
import { useEffect, useState } from "react";

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

const headerHeight: number = 112;
function GetGridHeight() {
    return window.innerHeight - headerHeight;
}

interface Apps {
    name: string;
    filename: string;
}

const tabs: Map<number, Apps> = new Map([
    [0, { name: "Desktop ICC", filename: "desktop.md" }],
    [1, { name: "Mobile ICC", filename: "mobile.md" }],
    [2, { name: "Admin Dashboard", filename: "admin.md" }],
    [3, { name: "Online Report", filename: "report.md" }],
    [4, { name: "Services", filename: "services.md" }]
]);

const Endpoint = "https://ios-icc-components.s3.dualstack.eu-west-1.amazonaws.com/changelogs/";

function ChangeLogs() {
    const [tabNumber, setTabNumber] = useState<number>(0);
    const [changeLogContent, setChangeLogContent] = useState<string>("");

    const handleTabSelect = (_: any, tabIndex: number) => {
        setTabNumber(tabIndex);
        LoadChangeLog(tabs.get(tabIndex)!.filename);
    };

    useEffect(() => {
        LoadChangeLog(tabs.get(0)!.filename);
    }, []);

    const LoadChangeLog = async (filename: string) => {
        var url = Endpoint + filename;
        var content = await ky.get(url).text();
        setChangeLogContent(content);
    }

    return (
        <div style={{ width: '100%', height: GetGridHeight() }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabNumber} onChange={handleTabSelect}>
                    {Array.from(tabs.entries()).map(([index, tab]) => <Tab key={index} label={tab.name} />)}
                </Tabs>
            </Box>

            <Markdown>
                {changeLogContent}
            </Markdown>
        </div>
    );
}

export default ChangeLogs;
